import { render, staticRenderFns } from "./workshow.vue?vue&type=template&id=5f3d4886&scoped=true&"
import script from "./workshow.vue?vue&type=script&lang=js&"
export * from "./workshow.vue?vue&type=script&lang=js&"
import style0 from "./workshow.vue?vue&type=style&index=0&id=5f3d4886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3d4886",
  null
  
)

export default component.exports